import React, { Component } from 'react'
import Types from 'prop-types'
import { connect } from 'react-redux'
import { List } from 'immutable'
import { formatMessage } from 'lib/intl'
import SelectList from 'components/common/SelectList'
import { setActiveFilter } from 'reducers/myJobsDataViewer/action'
import { setMyJobsDataViewerFilter } from 'reducers/profile/reducer'
import { createMyJobDataViewFilters } from 'helpers/myJobs'

class FilterDataField extends Component {
  onChange = values => {
    const { setMyJobsDataViewerFilter, profileDataViewerFilters } = this.props
    const { dataFields: profileDataFields } = profileDataViewerFilters.toJS()
    const dataFields = values.map(item => item.index)

    if (dataFields.length !== profileDataFields.length) {
      setMyJobsDataViewerFilter({ dataFields })
    }
  }

  render() {
    const { fieldList, activeFields } = this.props
    const activeFieldsArr = activeFields.toArray()
    const { dataFields } = createMyJobDataViewFilters()
    const values = (activeFieldsArr.length > 0 && activeFieldsArr) || dataFields

    return (
      <SelectList
        multiple
        withCheckBox
        hasAllValueOption
        variant="outlined"
        name="data_fields"
        label={formatMessage('data_fields')}
        list={fieldList}
        value={values}
        onClose={this.onChange}
        map={{
          index: 'id',
          text: 'name',
        }}
      />
    )
  }
}

FilterDataField.defaultProps = {
  activeFields: List([]),
  fieldList: List([]),
}

FilterDataField.propTypes = {
  activeFields: Types.instanceOf(List),
  fieldList: Types.instanceOf(List),
}

export default connect(
  store => ({
    activeFields: store.getIn([
      'profile',
      'jobsDataViewerFilters',
      'dataFields',
    ]),
    fieldList: store.getIn(['myJobsDataViewer', 'filters', 'fieldList']),
    profileDataViewerFilters: store.getIn(['profile', 'jobsDataViewerFilters']),
  }),
  {
    setActiveFilter,
    setMyJobsDataViewerFilter,
  },
)(FilterDataField)
